import { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Paper, Grid, TextField, Skeleton, Box, Typography, Button, Tooltip, IconButton } from '@mui/material';
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../../elements';
import CustomTab from '../../../elements/CustomTab';
import { useParams } from 'react-router';
import { deleteAssemblysEventApi, getAssemblysList, getDeliveryConditionApi } from '../apiServices';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus, getTextFieldRows } from '../../../../utils';
import AssemblyTable from '../../../elements/AssemblyTable';
import EditDeliveryCondition from '../components/EditDeliveryCondition';
import AddAssemblys from '../components/AddAssemblys';
import { getAssemblysApi } from '../../../../shared_elements/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import EditAssemblysEvent from '../components/EditAssemblysEvent';
import { DeletePopUp, PageLoader } from '../../../../shared_elements';
import { enqueueSnackbar } from 'notistack';
import { deleteAssemblysApi } from '../../redelivery/apiService';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from '../../../../hoc';
import { trackActivity } from '../../../../utils/mixpanel';
import { isMobile } from 'react-device-detect';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import moment from 'moment';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import { ShowAttachments } from '../../../../shared_elements/components';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const DeliveryCondition = () => {
    const dispatch = useDispatch()
    const { assemblysList, fileUploadDetails } = useSelector((state) => state.leases);
    const params = useParams();
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [editDeliveryCondition, setEditDeliveryCondition] = useState({ mode: '', modal: false, data: null });
    const [addAssemblys, setAddAssemblys] = useState({ mode: '', modal: false, data: null });
    const [deleteEvents, setDeleteEvents] = useState({ modal: false, data: null, })
    const [deleteAssemblys, setDeleteAssemblys] = useState({ modal: false, data: null, })
    const [editEvent, setEditEvent] = useState({ mode: '', modal: false, data: null });
    const [assemblysType, setAssemblysType] = useState([])
    const [isDropDownLoading, setIsDropDownLoading] = useState({ assembly: !(assemblysList?.length > 0), data: false, assemblyType: false });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [tabValue, setTabValue] = useState(0);
    const contentScrollSx = { maxHeight: "calc(100vh - 320px)", overflowY: "auto", pr: 1 };
    const [editMode, setEditMode] = useState(false);
    const [uploadfile, setUploadfile] = useState({ mode: '', modal: false, data: null });
    const [uploadFileProgressData, setUploadFileProgressData] = useState({});
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({});

    useEffect(() => {
        const uploadedFileData = getApiResponse("delivery_assembly_event", slug);
        setUploadFileProgressData({ uploadedFileData });
        getDeliveryConditionDetail('skeletonLoader', {});
        getAssemblysTypeList('skeletonLoader', {})
        dispatch(getAssemblysApi(params, { setIsDropDownLoading: setIsDropDownLoading }));
        trackActivity('Page Viewed', { page_title: 'Delivery Condition' })
    }, []);

    const getDeliveryConditionDetail = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, data: true })) : setLoading(true);
        globalGetService(getDeliveryConditionApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                setData(response.data.data);
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, data: false })) : setLoading(false);
            }
            else {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, data: false })) : setLoading(false);

            }
        })
    };

    const getAssemblysTypeList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, assemblyType: true })) : setLoading(true);
        globalGetService(getAssemblysList(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, assemblyType: false })) : setLoading(false);
                setAssemblysType(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setIsDropDownLoading(prev => ({ ...prev, assemblyType: false })) : setLoading(false);

            }
        })
    };


    const onDeleteAssembly = () => {
        setLoading(true);
        globalDeleteService(deleteAssemblysApi({ params, assembly_slug: deleteAssemblys?.data?.assembly_slug, }), { ids: [deleteAssemblys?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Assembly`, success_msg: response?.data?.message, item_ids: deleteAssemblys?.data, response: response?.data })
                    setDeleteAssemblys({ modal: false, data: null });
                    getAssemblysTypeList('fetch');
                    //   setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Assembly`, error_msg: response?.data?.message, item_ids: deleteAssemblys?.data, response: response?.data })
                }
            })
    }


    const onDeleteAssemblyEvent = () => {
        setLoading(true);
        globalDeleteService(deleteAssemblysEventApi({ params, asset: deleteEvents?.data?.asset, assembly_slug: deleteEvents?.data?.assembly_slug, event_slug: deleteEvents?.data?.event_slug }), { ids: [deleteEvents?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Assembly Event`, success_msg: response?.data?.message, item_ids: deleteEvents?.data, response: response?.data })
                    setDeleteEvents({ modal: false, data: null });
                    getAssemblysTypeList('fetch');
                    //   setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Assembly Event`, error_msg: response?.data?.message, item_ids: deleteEvents?.data, response: response?.data })
                }
            })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "delivery_redelivery_maintenance_event",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => { setUploadFileProgressData({ progressRefs, attachments, response }); },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getAssemblysTypeList('fetch');
            },
            onError: (err) => {
                enqueueSnackbar(err?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    };

    const onDeletAttachments = (deletedSlug) => {
        setUploadfile(prev => ({
            ...prev,
            data: { ...prev.data, attachments: prev.data.attachments.filter(item => item.slug !== deletedSlug) }
        }));
        getAssemblysTypeList('fetch');
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Delivery Condition`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-details-height lease-module-paper' elevation={0}>
                <LeasesNav type="terms" />
                <div className='lease-details-content lease-detail-content-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid className="delivery-paper-item responsive-grid" container alignItems='end'>
                            <Grid className="delivery-menu-dropdown" size={{ md: 12, xs: 12 }}>
                                <LeasesMenuList btnText='Delivery Condition' type="terms" />
                            </Grid>
                            <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }} >
                                <Box sx={{ display: "flex", justifyContent: "flex-end", padding: '0px', minHeight: '35px' }}>
                                    <ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} />
                                    {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "delivery_conditions", operationType: ['U'] }}>
                                        <Tooltip title="Edit"><EditIcon className='delivery-edit-btn' fontSize="small" color="primary" onClick={() => { setEditDeliveryCondition({ modal: true, data: { actual_delivery_date: data?.actual_delivery_date, contractual_delivery_date: data?.contractual_delivery_date, estimated_delivery_date: data?.estimated_delivery_date, delivery_location: data?.delivery_location, delivery_remarks: data?.delivery_remarks }, mode: 'add' }); handleItemClicked('EditIcon') }} /></Tooltip>
                                    </PermissionWrapper> */}
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Box className='tab-detail-container'>
                        <Grid container spacing={2} sx={{ height: "calc(100vh - 245px)", maxHeight: "calc(100vh - 245px)", overflow: "hidden" }}>
                            <Box sx={{ width: '100%', height: '100%' }}>
                                <CustomTab
                                    getAssemblysTypeList={getAssemblysTypeList}
                                    getAssemblysTypeActualConfigList={getDeliveryConditionDetail}
                                    setValue={setTabValue}
                                    value={tabValue}
                                    tabs={[
                                        {
                                            label: 'Delivery Config',
                                            content: (
                                                <Box className='assembly-paper' sx={{ maxHeight: "calc(100vh - 450px) !important", overflow: "auto", ...contentScrollSx }}>
                                                    <Grid size={{ md: 12, xs: 12 }} sx={{ paddingRight: '15px' }}>
                                                        <Box className="assembly-btn-container">
                                                            <Typography color='primary' className='delivery-header' >Delivery Assemblies</Typography>
                                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "delivery_conditions", operationType: ['C'] }}>
                                                                <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary action-btn-start-icon' onClick={() => { setAddAssemblys({ modal: true, data: { assemblies: null, base_TSN: data?.base_TSN, base_CSN: data?.base_CSN }, mode: 'add' }); handleItemClicked('Add Assembly Button') }}>Add Assembly</Button>
                                                            </PermissionWrapper>
                                                        </Box>
                                                    </Grid>
                                                    <Grid size={{ md: 12, xs: 12 }} sx={{ paddingRight: '15px' }}>
                                                        {
                                                            isDropDownLoading.assemblyType ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} variant="rectangular" height={40} />) :
                                                                assemblysType?.length > 0 ? assemblysType?.map((data, index) => {
                                                                    return (
                                                                        <AssemblyTable
                                                                            key={index}
                                                                            loading={skeletonLoader}
                                                                            viewRevisonHistory={(item, event, slug) => (console.log({ item, event, slug }), setRevisionHistory({ modal: true, data: event === "event" ? item : data, mode: "view", tableName: event }))}
                                                                            tsn={data?.tsn}
                                                                            csn={data?.csn}
                                                                            blockHours={data?.block_hours}
                                                                            asset={data?.asset}
                                                                            editEvent={editEvent}
                                                                            event={data?.maintenance_events}
                                                                            onDeleteAssembly={() => setDeleteAssemblys({ modal: true, data: { assembly_slug: data?.slug, id: data?.id } })}
                                                                            onEditAssemblys={() => setAddAssemblys({ modal: true, data: { ...data, asset: data?.asset, assembly_slug: data?.slug, event_slug: data.slug }, mode: 'edit' })}
                                                                            setEditEvent={setEditEvent}
                                                                            onViewAssemblys={() => setAddAssemblys({ modal: true, mode: "view", data: { ...data, asset: data?.asset, assembly_slug: data?.slug } })}
                                                                            onDelete={(event) => setDeleteEvents({ modal: true, data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event.slug } })}
                                                                            onEdit={(event) => setEditEvent({ modal: true, data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event.slug, assemblysType: assemblysType, maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) }, mode: 'edit' })}
                                                                            onAdd={() => setEditEvent({ modal: true, data: { asset: data?.asset, assembly_slug: data?.slug || "", event_slug: Array.isArray(data?.maintenance_events) && data?.maintenance_events[0]?.slug ? data.maintenance_events[0].slug : "", maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) }, mode: 'add' })}
                                                                            addAssemblys={addAssemblys}
                                                                            permissionKey='delivery_conditions'
                                                                            pageTitle='Delivery Condition'
                                                                            item={data}
                                                                            onView={(event) => setEditEvent({ modal: true, mode: "view", data: { ...event, asset: data?.asset, assembly_slug: data?.slug, event_slug: event?.slug, maintenance_types: data?.maintenance_events?.map(m => m?.maintenance_type) } })}
                                                                            viewFile={(eventData) => setUploadfile({ modal: true, mode: "file", data: eventData || data })}
                                                                            slug={slug?.slug}
                                                                            viewFileStatus={() => setUploadFileStatus({ modal: true, data: uploadFileProgressData, mode: 'view' })}
                                                                            uploadedFileData={uploadFileProgressData}
                                                                        />
                                                                    )
                                                                }) : (<Box sx={{ textAlign: 'center', height: "40px" }}><Box mt={1}>{"No Assemblies found for this lease"}</Box></Box>)
                                                        }
                                                    </Grid>
                                                </Box>
                                            )
                                        },
                                        {
                                            label: 'Delivery Information',
                                            content: (
                                                <Paper elevation={0} sx={{ padding: '3px 0px 7px 7px', borderRadius: 2, margin: '0px 1px 2px 1px', boxShadow: '0px 0px 0px 1px #BBBBBB', ...contentScrollSx }}>
                                                    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "delivery_conditions", operationType: ['U'] }}>
                                                            <Tooltip title="Edit">
                                                                <IconButton
                                                                    size="small"
                                                                    color="primary"
                                                                    className='delivery-edit-btn'
                                                                    onClick={() => {
                                                                        setEditDeliveryCondition({
                                                                            modal: true,
                                                                            data: {
                                                                                actual_delivery_date: data?.actual_delivery_date,
                                                                                contractual_delivery_date: data?.contractual_delivery_date,
                                                                                estimated_delivery_date: data?.estimated_delivery_date,
                                                                                delivery_location: data?.delivery_location,
                                                                                delivery_remarks: data?.delivery_remarks
                                                                            },
                                                                            mode: 'add'
                                                                        });
                                                                        handleItemClicked('EditIcon');
                                                                    }}
                                                                >
                                                                    <EditIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </PermissionWrapper>
                                                    </Box>
                                                    <Grid container spacing={2} sx={{ marginTop: '5px' }}>
                                                        <Grid size={{ md: 3, xs: 12 }}>
                                                            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
                                                                <TextField
                                                                    label="Delivery Date Contractual"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    margin="normal"
                                                                    disabled={true}
                                                                    fullWidth
                                                                    value={data?.contractual_delivery_date ? moment(data?.contractual_delivery_date).format("DD-MM-YYYY") : ""}
                                                                    slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid size={{ md: 3, xs: 12 }}>
                                                            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
                                                                <TextField
                                                                    label="Delivery Date Actual"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    margin="normal"
                                                                    disabled={true}
                                                                    fullWidth
                                                                    value={data?.actual_delivery_date ? moment(data?.actual_delivery_date).format("DD-MM-YYYY") : ""}
                                                                    slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid size={{ md: 3, xs: 12 }}>
                                                            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
                                                                <TextField
                                                                    label="Delivery Date Estimated"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    margin="normal"
                                                                    disabled={true}
                                                                    fullWidth
                                                                    value={data?.estimated_delivery_date ? moment(data?.estimated_delivery_date).format("DD-MM-YYYY") : ""}
                                                                    slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid size={{ md: 3, xs: 12 }}>
                                                            {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={40} />) : (
                                                                <TextField
                                                                    label="Delivery Location"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    margin="normal"
                                                                    disabled={true}
                                                                    fullWidth
                                                                    value={data?.delivery_location || ""}
                                                                    slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                />
                                                            )}
                                                        </Grid>
                                                        {editMode ?
                                                            <Grid size={{ md: 12, xs: 12 }}>
                                                                {isDropDownLoading.data ? (<Skeleton variant="rectangular" height={80} />) : (
                                                                    <TextField
                                                                        label="Remarks"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        margin="normal"
                                                                        disabled={true}
                                                                        fullWidth
                                                                        multiline
                                                                        rows={3}
                                                                        value={data?.delivery_remarks || ""}
                                                                        slotProps={{ input: { readOnly: true }, inputLabel: { shrink: true } }}
                                                                        sx={{ '& .MuiInputBase-root': { backgroundColor: '#f3f3f3' } }}
                                                                    />
                                                                )}
                                                            </Grid> : <Grid item size={{ md: 12, xs: 12 }}>
                                                                <LessMoreTextFieldComp label='Remarks' value={data?.delivery_remarks || ""} rows={getTextFieldRows(data?.delivery_remarks, 3, 164)} />
                                                            </Grid>}
                                                    </Grid>
                                                </Paper>
                                            )
                                        }
                                    ]}
                                />
                            </Box>
                        </Grid>
                    </Box>
                </div>
                {editDeliveryCondition.modal && (
                    <EditDeliveryCondition
                        editDeliveryCondition={editDeliveryCondition}
                        modeType={editDeliveryCondition?.mode}
                        getResponseBack={() => getDeliveryConditionDetail('fetch')}
                        onToggleModal={() => setEditDeliveryCondition({ modal: false, data: null, mode: '' })}
                    />
                )}
                {
                    addAssemblys.modal && (
                        <AddAssemblys
                            addAssemblys={addAssemblys}
                            isDropDownLoading={isDropDownLoading}
                            assemblysType={assemblysType}
                            setAddAssemblys={setAddAssemblys}
                            modeType={addAssemblys?.mode}
                            getResponseBack={() => getAssemblysTypeList('fetch')}
                            onToggleModal={() => setAddAssemblys({ modal: false, data: null, mode: '' })}
                        />
                    )
                }
                {
                    editEvent.modal && (
                        <EditAssemblysEvent
                            params={{ params, asset: editEvent?.data?.asset, assembly_slug: editEvent?.data?.assembly_slug, event_slug: editEvent?.data?.event_slug }}
                            editEvent={editEvent}
                            onToggleModal={() => setEditEvent({ modal: false, data: null, mode: '' })}
                            getResponseBack={() => getAssemblysTypeList('fetch')}
                            modeType={editEvent?.mode}
                            openAttachment={() => setUploadfile({ modal: true, data: editEvent?.data, mode: 'view' })}
                            fileUpload={handleUpload}
                        />
                    )
                }
                {deleteAssemblys.modal &&
                    <DeletePopUp
                        modal={deleteAssemblys.modal}
                        title='Delete Assembly'
                        content={`Are you sure, you want to Delete?`}
                        onToggleModal={() => setDeleteAssemblys({ modal: false, data: null })}
                        onDeleteRecords={() => onDeleteAssembly()}
                    />}
                {deleteEvents.modal &&
                    <DeletePopUp
                        modal={deleteEvents.modal}
                        title='Delete Event'
                        content={`Are you sure, you want to Delete?`}
                        onToggleModal={() => setDeleteEvents({ modal: false, data: null })}
                        onDeleteRecords={() => onDeleteAssemblyEvent()}
                    />}

                {revisionHistory?.modal &&
                    <RevisionHistory
                        section_type={"delivery"}
                        moduleName={revisionHistory?.tableName === "event" ? "delivery_redelivery_maintenance_event" : "delivery_redelivery_assembly"}
                        revisionHistory={revisionHistory}
                        onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                    />
                }

                {uploadfile?.modal &&
                    <ShowAttachments
                        url='delete-attachment'
                        moduleName="Delivery Condition"
                        attachmentsData={uploadfile}
                        getResponseBack={onDeletAttachments}
                        toggleModalFn={() => setUploadfile({ modal: false, mode: '', data: null })}
                        onViewDisabled={uploadfile?.mode === 'view'}
                        permissionKey="delivery_conditions"
                    />
                }
                <FileUploadLayout
                    uploadFileStatus={uploadFileStatus}
                    open={uploadFileStatus?.modal}
                    setUploadFileStatus={setUploadFileStatus}
                    uploadFileProgressData={uploadFileProgressData}
                    progressRefs={uploadFileProgressData?.progressRefs}
                    attachments={uploadFileProgressData?.attachments}
                    onDownloadComplete={() => setSlug({})}
                />
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </>
    )
};

export default RoleBaseAccess(DeliveryCondition, { application: 'lease_revamp', feature: 'delivery_conditions', operationType: ['R'] });
